import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

// Determine the base URL based on the environment
const baseURL = process.env.REACT_APP_DEEPGRAM_API_URL;

// Create an Axios instance with the base URL
const api = axios.create({
  baseURL: baseURL,
});

// Request interceptor
api.interceptors.request.use(
  async (config) => {
    try {
      // Make async call to get the token
      const token = await fetchAuthSession();

      // Apply the token to the request headers
      if (token.tokens) {
        config.headers[
          "Authorization"
        ] = `Bearer ${token.tokens.idToken.toString()}`;
      } else {
        config.headers["Authorization"] = `Bearer`;
      }

      // Return the modified config object
      return config;
    } catch (error) {
      // Handle any errors from the async call
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors here
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error("Response error:", error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Request error:", error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
